'use client';
import { CustomDefaultAccordion, PasswordContent } from '@/components';
import convertToReadable from '@/helpers/convertToReadable';

import { PersonalCabinet } from '@/components';
import { useRouter } from '@/i18n/navigation';
import useUserStore from '@/zustand/useUser';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { Button, Modal, Text } from 'rsuite';
import InfoImg from '../../../assets/icons/cart/Info.svg';
import styles from './styles.module.scss';

export default function CardTotal({
  handleClose,
  orderData,
  modalOpen,
  guest,
}: any) {
  const router = useRouter();
  const [openProducts2, setOpenProducts2] = useState(false);
  const userData = useUserStore((user: any) => user?.user);
  const isLoggedIn = Boolean(userData?.id);
  const [openModal, setOpenModal] = useState(false);
  const [auth, setAuth] = useState(false);

  const handleOrderClick = () => {
    if (isLoggedIn) {
      router.push('/order');
      handleClose?.();
    } else {
      setOpenModal(true);
    }
  };

  const totalPrice =
    orderData?.lines?.reduce(
      (
        total: number,
        line: {
          quantity: number;
          isGift?: boolean;
          variant: { pricing: { price: { net: { amount: number } } } };
        }
      ) => {
        if (line?.isGift) {
          return total;
        }

        const price = line?.variant?.pricing?.price?.net?.amount;
        const quantity = line?.quantity || 1;
        return total + price * quantity;
      },
      0
    ) || 0;
  const t = useTranslations('Components.card-total');
  return (
    <>
      <div className={styles.rootTotal}>
        <Text className={styles.title}>{t('total')}</Text>
        <Text className={styles.totalPrice}>
          {convertToReadable(totalPrice)} {t('price')}
        </Text>

        {Number(orderData?.totalBonuses) > 0 && (
          <div className={styles.bonusBox}>
            <div className={styles.bonusWrapper}>
              <Text className={styles.bonusText}>{t('bonus')}</Text>
              <InfoImg className={styles.bonusIcon} />
            </div>
            <Text className={styles.bonusCount}>
              +{convertToReadable(orderData?.totalBonuses)}
            </Text>
          </div>
        )}

        {Number(orderData?.totalBenefit?.amount) > 0 && (
          <>
            <hr className={styles.line} />
            <CustomDefaultAccordion
              title={t('benefit')}
              price={`-${convertToReadable(orderData?.totalBenefit?.amount)}`}
              isOpen={openProducts2}
              onClick={() => setOpenProducts2(!openProducts2)}
            >
              <div className={styles.benefits}>
                <div className={styles.item}>
                  <div className={styles.titleBenefits}>{t('discount')}</div>
                  <div className={styles.description}>
                    -{convertToReadable(orderData?.discountBenefit?.amount)}{' '}
                    {t('price')}
                  </div>
                </div>
                {orderData?.giftsPrice?.amount !== 0 && (
                  <div className={styles.item}>
                    <div className={styles.titleBenefits}>{t('gift')}</div>
                    <div className={styles.description}>
                      -{convertToReadable(orderData?.giftsPrice?.amount)}{' '}
                      {t('price')}
                    </div>
                  </div>
                )}
              </div>
            </CustomDefaultAccordion>
          </>
        )}

        <hr className={styles.line} />
        <Button
          type="button"
          onClick={handleOrderClick}
          className={styles.button1}
        >
          {t('formalize')}
        </Button>
        <Button
          onClick={() => modalOpen()}
          type="button"
          className={styles.button2}
          disabled={orderData?.installmentsWithoutIntegration.length === 0}
        >
          {t('formalize-credit')}
        </Button>
      </div>
      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        // size="sm"
        className={styles.modalCentered}
        backdrop="static"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div className={styles.cabinetWrapper}>
          {guest ? (
            <PersonalCabinet
              isGuest={true}
              handleOpen={() => setOpenModal(true)}
              handleClose={() => setOpenModal(false)}
            />
          ) : auth ? (
            <PasswordContent onClose={() => setOpenModal(false)} />
          ) : (
            <PersonalCabinet
              authWrapper={true}
              isGuest={true}
              handleOpen={() => setOpenModal(true)}
              handleClose={() => setOpenModal(false)}
              setAuth={() => setAuth(true)}
            />
          )}
        </div>
      </Modal>
    </>
  );
}
